import React from 'react';
import { Card, CardMedia, CardContent, Typography, Button, Box } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const ProductCard = ({ product, onBuyClick }) => {
    return (
        <Card sx={{ maxWidth: 300, bgcolor: 'background.paper', borderRadius: 3, boxShadow: 3, m: 1 }}>
            <CardMedia
                component="img"
                height="180"
                image={product.image}
                alt={product.name}
                sx={{ objectFit: 'cover' }}
            />
            <CardContent>
                <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                    {product.name}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    {product.description}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                    <Typography variant="h6" color="primary">
                        ${product.price}
                    </Typography>
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<ShoppingCartIcon />}
                        onClick={() => onBuyClick(product)}
                        sx={{ borderRadius: 4, fontWeight: 'bold' }}
                    >
                        Buy Now
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ProductCard;
